export const initDashboardComposition = () => ({
  type: "INIT_DASHBOARD_COMPOSITION"
});

export const fetchSlides = slides => ({
  type: "FETCH_SLIDES",
  payload: slides
});

export const setCompositionSlidesOrder = slidesOrder => ({
  type: "SET_COMPOSITION_SLIDES_ORDER",
  slidesOrder
});

export const setCompositionSlides = slides => ({
  type: "SET_COMPOSITION_SLIDES",
  slides
});

export const setCompositionLabel = labels => ({
  type: "SET_COMPOSITION_LABEL",
  labels
});

export const setDashboardCompositionIsPublic = isPublic => ({
  type: "SET_COMPOSITION_IS_PUBLIC",
  isPublic
});

export const saveDashboardComposition = resp => ({
  type: "SAVE_DASHBOARD_COMPOSITION",
  payload: resp
});

export const fetchDashboardMetadata = dashboardMetadata => ({
  type: "FETCH_DASHBOARD_METADATA",
  payload: dashboardMetadata
});

export const setDashboardIsEditable = isEditable => ({
  type: "SET_DASHBOARD_IS_EDITABLE",
  isEditable
});



// WEBPACK FOOTER //
// ./src/actions/actions/dashboardComposition.js